import React from 'react';

const Label = (props) => (
  <p
    style={{
      color: '#0D2059',
      fontFamily: 'Montserrat',
      fontWeight: 600,
      fontSize: '18px',
      paddingTop: '8px',
      lineHeight: '24px',
    }}
  >
    {props.title}
  </p>
);

export default Label;
